<div [ngStyle]="{ display: 'flex' }">
  <div class="train-numbers-wrapper">
    <qm-train-alarm-actions
      [trainDate]="alarm?.metadata?.payload?.trainDate"
      [tripNumber]="alarm?.metadata?.payload?.tripNumber"
      [trainCategory]="alarm?.metadata?.payload?.trainCategory"
      [openTab]="openTab"
      [reversed]="true"
      [ngbTooltip]="'Open train info' | translate">
    </qm-train-alarm-actions>
    <div class="arrow-line"></div>
    <fa-icon
      [icon]="['fas', 'play']"
      class="arrow"></fa-icon>
    <qm-train-alarm-actions
      [trainDate]="alarm?.metadata?.payload?.dependentTrainDate"
      [tripNumber]="alarm?.metadata?.payload?.dependentTripNumber"
      [trainCategory]="alarm?.metadata?.payload?.dependentTrainCategory"
      [openTab]="openTab"
      [ngbTooltip]="'Open train info' | translate">
    </qm-train-alarm-actions>
  </div>
</div>
